import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import WalmartSkusForm from "../../../components/forms/setup/walmartSkus/WalmartSkusForm";
import { BannerNotificationType } from "../../../components/SimpleBanner";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";

export function WalmartSkusViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [walmartSkus, setWalmartSkus] = useState({ data: [] });

  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const user_id = localStorage.getItem("id");

  const getWalmartSkus = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`sunWalmartSkus`, payload);
    setLoading(false);
    if (callResult.success) {
      setWalmartSkus(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createWalmartSku = async function (values) {
    const payload = { ...values, user_id: user_id };
    let callResult = await makePostApiCall("createSunWalmartSku", payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Walmart SKU added",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getWalmartSkus("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateWalmartSku = async function (walmartSku, values, index) {
    const payload = { ...values, id: walmartSku.id };
    let callResult = await makePutApiCall(`sunWalmartSkus/${walmartSku.id}`, payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Walmart SKU updated",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getWalmartSkus("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddWalmartSkuSlideOver = () => {
    setSlideOver({
      childComponent: (
        <WalmartSkusForm
          isEdit={false}
          setOpen={setSlideOver}
          actionCall={createWalmartSku}
        />
      ),
      open: true,
    });
  };

  const viewWalmartSkuDetails = async function (walmartSku, index) {
    setSlideOver({
      childComponent: (
        <WalmartSkusForm
          walmartSku={walmartSku}
          index={index}
          isEdit={true}
          setOpen={setSlideOver}
          actionCall={updateWalmartSku}
        />
      ),
      open: true,
    });
  };

  const deleteWalmartSku = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteSunWalmartSku/${id}`, {});
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getWalmartSkus("", 1);
      setShowSimpleNotification({
        show: true,
        title: callResult.data.message || "Walmart SKU deleted",
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteWalmartSku = function (walmartSku, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteWalmartSku(walmartSku.id, index)}
          message={`Are you sure you want to delete the SKU mapping for ${walmartSku.solmaz_plu}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    askDeleteWalmartSku,
    emptyModal,
    getWalmartSkus,
    loading,
    walmartSkus,
    openAddWalmartSkuSlideOver,
    setEmptyModelOpen,
    setSlideOver,
    setShowSimpleNotification,
    slideOver,
    showSimpleNotification,
    viewWalmartSkuDetails,
  };
}

